import React, { useState } from "react";
import styled from "styled-components";
import LifeAtTextInput from "@common/LifeAtTextInput/LifeAtTextInput";
import { UserContextType, useUserContext } from "@contexts/UserContext";
import Styles from "@themes/Styles";
import { updateUserDisplayName } from "@user/service/UserService";

const DisplayNameWrapper = styled.span`
    min-height: 30px;
    height: auto;

    padding: 4px;

    border: 1px solid ${(props) => props.theme.borderPrimary};
    border-radius: ${Styles.borderRadiusSharp};

    cursor: text;
`;

const USER_DISPLAY_NAME_MIN_LENGTH = 2;
const USER_DISPLAY_NAME_MAX_LENGTH = 31;

interface UserDisplayNameSettingProps {
    onNameChangeCallback: () => void;
    errorCallback: () => void;
}
export function UserDisplayNameSetting(props: UserDisplayNameSettingProps) {
    const { user, userData }: UserContextType = useUserContext();

    const [isEditDisplayName, setIsEditDisplayName] = useState(false);
    const [userDisplayNameVal, setUserDisplayNameVal] = useState(user.displayName);

    const onDisplayNameUpdate = (newName: string) => {
        if (newName.length >= USER_DISPLAY_NAME_MIN_LENGTH && newName.length <= USER_DISPLAY_NAME_MAX_LENGTH) {
            setUserDisplayNameVal(newName);
            setIsEditDisplayName(false);
            updateUserDisplayName(user, newName, userData.displayName !== undefined);
            props.onNameChangeCallback();
        } else {
            props.errorCallback();
        }
    };

    return (
        <DisplayNameWrapper onClick={() => setIsEditDisplayName(true)}>
            <LifeAtTextInput
                textValue={userDisplayNameVal}
                isEditing={isEditDisplayName}
                finishEditCallback={() => setIsEditDisplayName(false)}
                handleUpdate={onDisplayNameUpdate}
            />
        </DisplayNameWrapper>
    );
}
